<script setup>
import { computed, onMounted } from 'vue';
import { useMapGetter, useStore } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import ButtonV4 from 'next/button/Button.vue';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';

const store = useStore();
const uiFlags = useMapGetter('accounts/getUIFlags');
const { currentAccount } = useAccount();

const isSubscriptionSuspended = computed(() => {
  return currentAccount.value?.custom_attributes?.subscription_status?.toLowerCase() === 'suspended';
});

const title = computed(() => {
  if (isSubscriptionSuspended.value) {
    return 'APP_GLOBAL.SUBSCRIPTION_SUSPENDED.TITLE';
  }

  return 'APP_GLOBAL.ACCOUNT_SUSPENDED.TITLE';
});

const message = computed(() => {
  if (isSubscriptionSuspended.value) {
    return 'APP_GLOBAL.SUBSCRIPTION_SUSPENDED.MESSAGE';
  }

  return 'APP_GLOBAL.ACCOUNT_SUSPENDED.MESSAGE';
});

const toggleSupportWidgetVisibility = () => {
  if (window.$chatwoot) {
    window.$chatwoot.toggleBubbleVisibility('show');
  }
};

const setupListenerForWidgetEvent = () => {
  window.addEventListener('chatwoot:on-message', () => {
    toggleSupportWidgetVisibility();
  });
};

const openBillingPortal = () => {
  store.dispatch('accounts/checkout');
};

onMounted(() => {
  toggleSupportWidgetVisibility();
  setupListenerForWidgetEvent();
});
</script>

<template>
  <div class="items-center bg-n-slate-2 flex justify-center h-full w-full">
    <EmptyState :title="$t(title)" :message="$t(message)">
      <div v-if="isSubscriptionSuspended" class="flex justify-center mt-3">
        <ButtonV4
          sm
          solid
          blue
          :is-loading="uiFlags.isCheckoutInProcess"
          @click="openBillingPortal"
        >
          {{ $t('APP_GLOBAL.SUBSCRIPTION_SUSPENDED.BUTTON') }}
        </ButtonV4>
      </div>
    </EmptyState>
  </div>
</template>
